import Login1Container from "../../../components/pages/other/Login1";

const Login1 = () => {
  return <Login1Container />;
};

export default Login1;
